module.exports = __webpack_public_path__ + "static/19-aerial-views-iv-b001ecd90a4caef0d73193537335e1c6.jpeg";